import JSZip from 'jszip'

/**
 * Download multiple images as a zip file
 * @param {Array} items - Array of items with url property
 * @param {string} zipFileName - Name of the zip file (default: 'ai-backgrounds.zip')
 * @param {string} filePrefix - Prefix for individual file names (default: 'background_')
 * @returns {Promise<void>}
 */
export const downloadImagesAsZip = async (items, zipFileName = 'ai-backgrounds.zip', filePrefix = 'background_') => {
    if (!items || items.length === 0) {
        throw new Error('No items to download')
    }

    try {
        const zip = new JSZip()
        
        // Download all images and add to zip
        await Promise.all(
            items.map(async (item, index) => {
                try {
                    if (!item.url) {
                        console.warn(`Item ${index + 1} has no URL, skipping`)
                        return
                    }
                    
                    const response = await fetch(item.url)
                    if (!response.ok) {
                        throw new Error(`Failed to fetch image ${index + 1}: ${response.statusText}`)
                    }
                    
                    const blob = await response.blob()
                    // Extract file extension from URL or use default
                    const urlParts = item.url.split('.')
                    const extension = urlParts.length > 1 ? urlParts[urlParts.length - 1].split('?')[0] : 'jpg'
                    const fileName = `${filePrefix}${index + 1}.${extension}`
                    zip.file(fileName, blob)
                } catch (error) {
                    console.error(`Failed to download image ${index + 1}:`, error)
                    // Continue with other images even if one fails
                }
            })
        )

        // Generate zip file
        const zipBlob = await zip.generateAsync({type: 'blob'})
        const zipUrl = URL.createObjectURL(zipBlob)
        
        // Download zip
        const link = document.createElement('a')
        link.href = zipUrl
        link.download = zipFileName
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        
        // Clean up
        URL.revokeObjectURL(zipUrl)
    } catch (error) {
        console.error('Failed to create zip file:', error)
        throw error
    }
}

